module.exports = __webpack_public_path__ + "static/media/logo-full-148.e52ec8f8.png";